import { forwardRef, useImperativeHandle, useState } from 'react';

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { NumberInput, TextareaInput } from 'components/FormControl';

import { yupResolver } from '@hookform/resolvers/yup';
import { TOAST } from 'constant';
import { awardSchema } from 'features/ScientificProfile/validation';
import { toast } from 'layout';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

const formOptions = { resolver: yupResolver(awardSchema) };

const AwardDialog = forwardRef((props, ref) => {
  const { t } = useTranslation();

  const [awardControl, setAwardControl] = useState();
  const [visible, setVisible] = useState(false);

  const {
    control,
    watch,
    reset,
    trigger,
    formState: { errors, dirtyFields },
  } = useForm({ ...formOptions, mode: 'onChange' });
  // #region Event

  useImperativeHandle(
    ref,
    () => ({
      open: (_awardControl) => {
        setAwardControl(_awardControl);
        setVisible(true);
        if (_awardControl.type === 'INSERT') {
          reset({});
        } else if (_awardControl.type === 'UPDATE') {
          reset(_awardControl.value);
        }
      },
    }),
    []
  );

  const handleAddAward = async () => {
    const isValidTrigger = await trigger();
    if (!isValidTrigger) {
      toast(TOAST.ERROR, t('errorMessage.validationErrorMessage'));
      return;
    }

    const data = watch();

    const { insert, update, index, type } = awardControl;

    if (type === 'INSERT' && insert) {
      insert(index, data);
    } else if (type === 'UPDATE' && update) {
      update(index, data);
    }
    reset({});
    setVisible(false);
  };
  // #endregion Event

  return (
    <Dialog
      header={
        awardControl?.type === 'INSERT'
          ? t('scientificProfile.otherInfo.award.add')
          : t('scientificProfile.otherInfo.award.update')
      }
      visible={visible}
      onHide={() => {
        setVisible(false);
      }}
      draggable={false}
      className="w-full sm:w-7 lg:w-6"
    >
      <div className="grid p-fluid">
        <div className="col-12">
          <TextareaInput
            label={t('scientificProfile.otherInfo.award.name')}
            name="name"
            control={control}
            errors={errors}
            isRequired
          />
        </div>
        <div className="col-12">
          <TextareaInput
            label={t('scientificProfile.otherInfo.award.description')}
            name="description"
            control={control}
            errors={errors}
            isRequired
          />
        </div>
        <div className="col-12">
          <TextareaInput
            label={t('scientificProfile.otherInfo.award.placeOfIssue')}
            name="placeOfIssue"
            control={control}
            errors={errors}
            isRequired
          />
        </div>

        <div className="col-6">
          <NumberInput
            label={t('scientificProfile.otherInfo.award.yearOfIssue')}
            name="yearOfIssue"
            control={control}
            errors={errors}
            min={0}
            isRequired
          />
        </div>
      </div>

      <div className="flex flex-wrap justify-content-end mt-4">
        <Button
          label={t('formLayout.action.cancel')}
          severity="danger"
          onClick={() => setVisible(false)}
          className="mr-1 w-8rem"
        />
        <Button
          label={
            awardControl?.type === 'INSERT'
              ? t('formLayout.action.add')
              : t('formLayout.action.update')
          }
          severity="info"
          type="submit"
          className="w-8rem"
          onClick={handleAddAward}
          disabled={!Object.keys(dirtyFields).length}
        />
      </div>
    </Dialog>
  );
});

AwardDialog.propTypes = {};

AwardDialog.defaultProps = {};

export default AwardDialog;
